const environment = "test";

export const cancelBookingDatas = {
  intro: `This API sends a cancellation request for a booking using a given bookingId. The bookingId is obtained from the "Booking With Vehicle" API after the booking is confirmed.`,

  endpoint:
    environment === "test"
      ? `https://testapi.drivado.com/api/v1/api/apicancelBooking?email=email`
      : `https://api.drivado.com/api/v1/api/apicancelBooking?email=email`,

  responseDes: `The response provides the details of the entire booking, including the booking status, which will be updated to "cancelled."`,
};
